import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import PageHeader from '../components/PageHeader';

const Conferences = () => {
  const { t } = useTranslation();
  const conferences = t('conferences.items', { returnObjects: true });

  return (
    <div>
      <PageHeader eyebrow="Kalle Glauch" title={t('conferences.title')} lead={t('conferences.lead')} />

      <div className="mx-auto max-w-5xl px-6 py-14 md:px-10 md:py-16">
        {Array.isArray(conferences) &&
          conferences.map((conf, index) => (
            <motion.article
              key={index}
              className="border-b border-line py-6 first:pt-0 last:border-0"
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.32, delay: (index % 4) * 0.04 }}
            >
              <div className="mb-2 flex flex-wrap items-center gap-x-2.5 gap-y-1">
                <span className="eyebrow">{conf.type}</span>
                <span className="text-ink-400">·</span>
                <span className="text-xs tracking-wide text-ink-400">{conf.date}</span>
                <span className="text-ink-400">·</span>
                <span className="text-xs tracking-wide text-ink-400">{conf.location}</span>
              </div>
              <h2 className="text-base font-semibold leading-snug text-ink-900">{conf.name}</h2>
              <p className="mt-1.5 font-display text-sm italic leading-relaxed text-ink-600">{conf.presentation}</p>
              {conf.url && (
                <a
                  href={conf.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2.5 inline-flex items-center gap-1.5 text-sm text-navy-600 transition-colors hover:text-navy-800"
                >
                  {t('conferences.viewDetails')}
                  <ExternalLink size={14} />
                </a>
              )}
            </motion.article>
          ))}
      </div>
    </div>
  );
};

export default Conferences;
